import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { switchMap } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';
import { PanierService } from '../../manage/panier/panier.service';
import { TableReservationService } from '../table-reservation/table-reservation.service';
import { AuthService } from '../../auth/auth.service';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { normalizeSM } from '../fulle/fulle-saleMethod/fulle-saleMethod.interface';

@Injectable({
  providedIn: 'root'
})

/**
 * Récupération des modes de vente
 */
export class SalemethodService {
  public static TAG_STORAGE: string = "sale_method"

  private currSaleMeth: BehaviorSubject<any> = new BehaviorSubject(null);

  private lastIdPointOfSaleGet: number = 0;
  private saleMethodsList: any = [];

  constructor(
    private tools: ToolsService,
    private panMan: PanierService,
    private trService: TableReservationService,
    private authService: AuthService,
    private baseClient: BaseclientService
  ) {

  }

  // Get sales methods by point of sale id
  getSaleMethods(): Observable<any> {
    // console.log("[DEBUG] je rentre dans getSaleMethods de salemethod.service");

    const pos: any = this.tools.getStor("point_of_sale");
    // console.log("pos: ", pos);

    // Point de vente
    if (pos) {
      // console.log("[DEBUG] je rentre dans if (pos) {");
      // console.log("this.lastIdPointOfSaleGet: ", this.lastIdPointOfSaleGet);
      // console.log("this.saleMethodsList.length > 0: ", this.saleMethodsList.length);
      // Déja stocké
      if ((pos.id == this.lastIdPointOfSaleGet) && (this.saleMethodsList.length > 0)) {
        // console.log("pos.id: ", pos.id);
        // création d'une Promise qui renvoie this.saleMethodsList (donc le tableau de méthodes de vente) transformée en Observable avec from(...)
        return from(new Promise((resolve) => {
          resolve(this.saleMethodsList);
        }));
      }

      this.lastIdPointOfSaleGet = pos.id;

      const params = {
        id_point_of_sale: pos.id,
        enable_online_order: 1,
      };

      return from(this.baseClient.postBaseApi("sale_methods", params)).pipe(
        switchMap(methods => this.parseSaleMethods(methods.sale_methods.list))
      )
    }
    // Aucun point de vente préchargé
    else {
      return from([])
    }
  }

  // Parse sales methods
  parseSaleMethods(methods: any): Promise<any> {
    let methodsVisible: any = [];
    methods.forEach((element: any) => {
      element.disable_authentification_info_notes = element.disable_authentification_info_notes ? element.disable_authentification_info_notes : null;
      methodsVisible.push(element);
    });
    this.saleMethodsList = methodsVisible
    const pointOfSale = this.tools.getStor("point_of_sale");
    return new Promise((resolve) => {
      if (this.saleMethodsList.length === 1) {
        this.trService.$_getBookingSettings(pointOfSale.id_webshop).then(bookingSettings => {
          if (bookingSettings.code > 0)
            this.saleMethodsList[0].bookingActive = true;
          this.saleMethodsList[0].onlyOneSM = true;
          resolve(this.saleMethodsList);
        });
      } else {
        resolve(this.saleMethodsList);
      }
    });
  }

  // Set the sale method into the localstorage and observable

  setSaleMeth(sm: any, same: any = false) {

    if (!same) {
      this.panMan.removePanier();
      this.tools.removeStor("info_notes");
    }
    if (sm) {
      this.parseLimitOrderGap(sm);
      this.parseDisableAuth(sm);
    }
    this.tools.setStor(SalemethodService.TAG_STORAGE, sm);
    this.currSaleMeth.next(sm);
  }

  // Return the Observable of the current sale method
  getSaleMeth(): Observable<any> {
    return this.currSaleMeth.asObservable();
  }

  // Update the current sale method
  initSM(): Promise<any> {

    const that = this;

    return new Promise((resolve) => {

      const storPOS = that.tools.getStor("point_of_sale");


      if (storPOS) {

        that.getSaleMethods().subscribe(salemeths => {


          const storSM = that.tools.getStor(SalemethodService.TAG_STORAGE);


          if (storSM) {

            let flagSm = null;

            salemeths.map((sm: any) => {
              if (parseInt(sm.id) === parseInt(storSM.id)) {
                flagSm = sm;
                if (storSM.payment_type) {

                  flagSm.payment_type = this.checkOldPaymentType(storSM.payment_type, storPOS, sm);

                }
              }


            });

            if (flagSm) {

              that.setSaleMeth(flagSm, true);

            } else {

              that.tools.removeStor(SalemethodService.TAG_STORAGE);
              salemeths = [];

            }

          }

          resolve(salemeths);

        });

      } else {


        resolve(null);

      }

    });
  }


  // Parse limite gap to minute or hour
  parseLimitOrderGap(sm: any) {
    sm = normalizeSM(sm);
    // console.log("FulleSaleMethodService - parseLimitOrderGap - sm : ", sm)
    const gap = sm.limitOrderGap % 60 === 0 ? sm.limitOrderGap / 60 : sm.limitOrderGap;
    // console.log("FulleSaleMethodService - parseLimitOrderGap - gap : ", gap)
    let timeUnit = sm.limitOrderGap % 60 === 0 ? "heure" : "minute";
    // console.log("FulleSaleMethodService - parseLimitOrderGap - timeUnit : ", timeUnit)
    gap > 0 ? timeUnit += "s" : "";
    if (gap)
      sm.limitOrderGapStr = gap + " " + timeUnit;
  }


  checkOldPaymentType(payment_type: any, storPOS: any, sm: any) {
    let result = null;

    //sm salemethod refresh
    if (payment_type && storPOS && sm) {


      switch (payment_type) {
        case 'counter':
          result = sm.enable_counter_payment ? payment_type : null;
          break;
        case 'secure_counter':
          result = sm.enable_secure_counter_payment ? payment_type : null;
          break;
        case 'online':
          result = sm.enable_online_payment && storPOS.stripe_account ? payment_type : null;
          break;
        case 'stripe':
          result = sm.enable_online_payment && storPOS.stripe_account ? payment_type : null;
          break;
        case 'payzen':
          result = sm.enable_online_payment && storPOS.payzen_account ? payment_type : null;
          break;
        case 'online_paypal':
          result = sm.enable_online_payment && storPOS.paypal_account ? payment_type : null;
          break;


        default:
          result = null;
      }

    }

    return result
  }

  parseDisableAuth(sm: any) {
    sm.disable_authentification_info_notes = sm.disable_authentification_info_notes ? sm.disable_authentification_info_notes : null;
  }
}
